import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { Header } from "@/components/layout/header";
import { Suspense, lazy } from "react";
import { Sheet } from "@/components/ui/sheet";
import { CartDrawer } from "@/components/cart/cart-drawer";
import { useCart } from "@/lib/cart";
import { useLocation } from "wouter";

const Home = lazy(() => import("@/pages/home"));
const About = lazy(() => import("@/pages/about"));
const Legal = lazy(() => import("@/pages/legal"));
const CrushManufacturingPartner = lazy(() => import("@/pages/crush-manufacturing-partner"));
const TalentSearch = lazy(() => import("@/pages/talent-search"));
const NotFound = lazy(() => import("@/pages/not-found"));

function Router() {
  return (
    <Switch>
      <Route path="/about" component={About} />
      <Route path="/legal" component={Legal} />
      <Route path="/the-path-forward" component={CrushManufacturingPartner} />
      <Route path="/talent-search" component={TalentSearch} />
      <Route path="/" component={Home} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  const [location] = useLocation();
  const { isOpen, setIsOpen } = useCart();
  const showHeader = location !== "/";

  return (
    <QueryClientProvider client={queryClient}>
      <div className="flex flex-col min-h-screen">
        {showHeader ? <Header /> : null}
        <main className={showHeader ? "flex-grow mt-[calc(4rem+1.5rem)]" : "flex-grow"}>
          <Suspense
            fallback={
              <div className="container mx-auto px-4 py-16 text-[rgba(24,34,24,0.6)]">
                Loading...
              </div>
            }
          >
            <Router />
          </Suspense>
        </main>
      </div>
      <Sheet open={isOpen} onOpenChange={setIsOpen}>
        <CartDrawer />
      </Sheet>
      <Toaster />
    </QueryClientProvider>
  );
}

export default App;
